import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <motion.header 
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg py-2' : 'bg-transparent py-4'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 100, damping: 20 }}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <motion.div 
          className="flex items-center"
          whileHover={{ scale: 1.05 }}
        >
          <motion.span 
            className={`text-2xl font-bold ${scrolled ? 'text-[#E60023]' : 'text-white'}`}
            whileHover={{ rotate: [0, -5, 5, 0] }}
            transition={{ duration: 0.5 }}
          >
            TruckParts
          </motion.span>
        </motion.div>
        
        {/* Navigation pour desktop */}
        <nav className="hidden md:flex space-x-8">
          {['Catalogue', 'Marques', 'Comment ça marche', 'À propos', 'Contact'].map((item, index) => (
            <motion.a
              key={index}
              href="#"
              className={`font-medium ${scrolled ? 'text-gray-800 hover:text-[#E60023]' : 'text-white hover:text-gray-200'}`}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              {item}
            </motion.a>
          ))}
          <motion.button
            className="bg-[#E60023] text-white px-4 py-2 rounded-md font-medium"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Mon Compte
          </motion.button>
        </nav>
        
        {/* Bouton hamburger pour mobile */}
        <motion.button 
          className="md:hidden z-50 relative"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          whileTap={{ scale: 0.9 }}
        >
          <div className={`w-6 h-0.5 bg-${scrolled ? 'black' : 'white'} mb-1.5 transition-transform ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></div>
          <div className={`w-6 h-0.5 bg-${scrolled ? 'black' : 'white'} mb-1.5 transition-opacity ${mobileMenuOpen ? 'opacity-0' : ''}`}></div>
          <div className={`w-6 h-0.5 bg-${scrolled ? 'black' : 'white'} transition-transform ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></div>
        </motion.button>
        
        {/* Menu mobile */}
        <motion.div
          className="md:hidden fixed inset-0 bg-[#E60023] z-40"
          initial={{ opacity: 0, x: '100%' }}
          animate={{ 
            opacity: mobileMenuOpen ? 1 : 0,
            x: mobileMenuOpen ? '0%' : '100%'
          }}
          transition={{ type: 'tween', duration: 0.3 }}
        >
          <div className="flex flex-col justify-center items-center h-full space-y-8">
            {['Catalogue', 'Marques', 'Comment ça marche', 'À propos', 'Contact', 'Mon Compte'].map((item, index) => (
              <motion.a
                key={index}
                href="#"
                className="text-white text-2xl font-medium"
                initial={{ y: 20, opacity: 0 }}
                animate={{ 
                  y: mobileMenuOpen ? 0 : 20, 
                  opacity: mobileMenuOpen ? 1 : 0 
                }}
                transition={{ delay: 0.1 * index }}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item}
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </motion.header>
  );
};

export default Header;
